import { CompsetPriceTypes, State } from '@/views/calendar-configuration/calendar-configuration.types';
import { deltaOptions }             from '@/views/calendar-configuration/calendar-configuration.variables';

const state: State = {
  calendarConfiguration: {
    delta: deltaOptions[ 0 ],
    compsetPriceType: CompsetPriceTypes.MEDIAN,
  },
  configurationLoading: false,
};

export default state;
